<template>
    <v-expansion-panel class="">
    <v-expansion-panel-content class="secondary textwhite">
      <template v-slot:header>
        <div class="title">{{docTitle}}</div>
      </template>
      <v-layout row style="background-color: white">
      <v-flex xs12 sm6>
        <v-list dense two-line> 
            <v-list-tile >
                <v-list-tile-action>
                <v-icon>person</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                {{$store.state.customers[$store.state.selectedCustIndex].No}}
                -
                {{$store.state.customers[$store.state.selectedCustIndex].Name}}
                </v-list-tile-content>            
            </v-list-tile>
            <v-divider inset></v-divider>                     
            <v-list-tile >
                <v-list-tile-action>
                <v-icon>email</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                <v-list-tile-title>
                    {{$store.state.customers[$store.state.selectedCustIndex].Email}}
                </v-list-tile-title>
                </v-list-tile-content>            
            </v-list-tile>                        
        </v-list>      
      </v-flex>
      <v-flex xs12 sm6>
        <v-list dense>             
            <v-list-tile >
                <v-list-tile-action>
                <v-icon>group</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                <v-list-tile-title>
                    {{$store.state.customers[$store.state.selectedCustIndex].CustomerPriceGroup}}
                </v-list-tile-title>
                </v-list-tile-content>            
            </v-list-tile>
            <v-divider inset></v-divider>                      
            <v-list-tile >
                <v-list-tile-action>
                <v-icon>payment</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                <v-list-tile-title>
                    {{$store.state.customers[$store.state.selectedCustIndex].Payment}}
                </v-list-tile-title>
                </v-list-tile-content>            
            </v-list-tile>                    
        </v-list>      
      </v-flex>
      </v-layout>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
export default {
    name: 'cabeceraPedido',
    data(){
        return {
            docTitle: ''
        }
    },
    computed:{
        
        
    },
    mounted(){
        this.docTitle = this.getDocTitle();
    }

}
</script>
<style scoped>
.textwhite{
    color: white !important
    }
    @media screen {
        
    }

@media (max-width: 3840px) {
.title{
    font-size: large !important;
}
}
@media (max-width: 960px) {
.title{
    font-size: medium !important;
}
}

</style>

